export enum MembershipPeriod {
  NONE = 0,
  MONTH = 1,
  YEAR = 2,
  SINGLE_PAYMENT = 3,
  UNLIMITED = 4,
}
